import { SECURITY_VIEW_ID_PREFIX } from "security-app/routing/Routes";
import { RouterRoutes } from "security-app/routing/Router";
const entityRoutesResolver = (id, type) => {
  var _a;
  if (id.startsWith(SECURITY_VIEW_ID_PREFIX) && type === "dashboard") {
    return (_a = RouterRoutes.find(({ entityId }) => entityId === id)) == null ? void 0 : _a.path;
  }
  return null;
};
export default entityRoutesResolver;
